import { render, staticRenderFns } from "./importacaoRetornoAberturaConta.vue?vue&type=template&id=21b22185&scoped=true&"
import script from "./importacaoRetornoAberturaConta.vue?vue&type=script&lang=js&"
export * from "./importacaoRetornoAberturaConta.vue?vue&type=script&lang=js&"
import style0 from "./importacaoRetornoAberturaConta.vue?vue&type=style&index=0&id=21b22185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b22185",
  null
  
)

export default component.exports